module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/5-f81f95ad2967c32c25a1109be314ab78.jpeg";